import { createFileRoute } from "@tanstack/react-router";
import { useButtonStore } from "src/components/ButtonState";
import { useJoinState } from "src/components/join/JoinState";
import { useUserState } from "src/components/UserState";
import SingleSelectionPageComponent from "src/features/SingleSelectionPageComponent";

export const Route = createFileRoute("/join/_layout/isNew")({
  component: RouteComponent,
});

function RouteComponent() {
  const setButtonEnabled = useButtonStore((state) => state.setButtonEnabled);
  const setSelections = useUserState((state) => state.setSelections);
  const invitingUserName = useJoinState((state) => state.invitingUserName);

  return (
    <SingleSelectionPageComponent
      titleText="Are you an active trainwell client?"
      bodyText={`We'll get you set up with ${invitingUserName}'s team.`}
      items={[
        { label: "Yes, I already use trainwell!", id: "member" },
        { label: "Nope, no active account!", id: "first_time" },
      ]}
      selectionText={undefined}
      onSelectionChange={(selectedItem) => {
        console.log(selectedItem);
        if (selectedItem === null) {
          // Disable button.
          setButtonEnabled(false);
        } else {
          setSelections("/join/isNew", [selectedItem]);
          setButtonEnabled(true);
        }
      }}
    />
  );
}
